import { useCallback, useState } from "react";

import { extractAPIRequestErrorMessage } from "utils";

import { useAPI } from "./useAPI";
import { useError } from "./useError";
import { useLoading } from "./useLoading";
import { useRoleContext } from "./useRoleContext";

export function useRemoveSupplier() {
  const { api } = useAPI();
  const { role } = useRoleContext();

  if (role && role.type !== "SHIPPER") {
    throw new Error("useRemoveSupplier can only be used by shipper users");
  }

  const { error, setError } = useError();
  const { loading, setLoading } = useLoading(false);
  const [success, setSuccess] = useState<boolean>(false);

  const resetState = () => {
    setError(null);
    setLoading(false);
    setSuccess(false);
  };

  const removeSupplier = useCallback(
    (supplierShipperId: number) => {
      if (!role) return;

      setError(null);
      setLoading(true);

      const url = `/shippers/${role.id}/suppliers/${supplierShipperId}`;

      api("delete", url)
        .then(() => {
          setSuccess(true);
          setError(null);
        })
        .catch((e) => {
          setError(
            extractAPIRequestErrorMessage(e, "Failed to remove supplier"),
          );
          setSuccess(false);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [api, role, setError, setLoading],
  );

  return {
    loading,
    error,
    success,
    removeSupplier,
    resetState,
  };
}
